import React from 'react';

type IProps = {
    style?: Object;
};

const Spinner = (props?: IProps) => {
    const styles = {
        '--spinner-size': '24px',
        ...props?.style,
    };
    return (
        <div
            className='c-spinner  c-spinner--small'
            aria-live='polite'
            aria-busy='true'
            style={{ ...styles } as React.CSSProperties}
        >
            <div className='c-spinner__loader'>
                <span className='c-spinner__element'></span>
                <span className='c-spinner__element'></span>
                <span className='c-spinner__element'></span>
                <span className='c-spinner__element'></span>
                <span className='c-spinner__element'></span>
                <span className='c-spinner__element'></span>
                <span className='c-spinner__element'></span>
                <span className='c-spinner__element'></span>
            </div>
        </div>
    );
};

export default Spinner;
